import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faCheckCircle,
  faClock,
  faShip,
  faBoxOpen,
  faFileAlt,
  faTruck,
  faWarehouse,
} from "@fortawesome/free-solid-svg-icons";

// Status color and icon mapping
const statusConfig = {
  Alert: {
    bgColor: "bg-yellow-100",
    textColor: "text-yellow-800",
    borderColor: "border-yellow-200",
    icon: faExclamationTriangle,
  },
  "In Progress": {
    bgColor: "bg-blue-100",
    textColor: "text-blue-800",
    borderColor: "border-blue-200",
    icon: faClock,
  },
  Arribo: {
    bgColor: "bg-green-100",
    textColor: "text-green-800",
    borderColor: "border-green-200",
    icon: faShip,
  },
  "Desconsolidacion LCL": {
    bgColor: "bg-purple-100",
    textColor: "text-purple-800",
    borderColor: "border-purple-200",
    icon: faBoxOpen,
  },
  Revalidacion: {
    bgColor: "bg-teal-100",
    textColor: "text-teal-800",
    borderColor: "border-teal-200",
    icon: faFileAlt,
  },
  Despacho: {
    bgColor: "bg-indigo-100",
    textColor: "text-indigo-800",
    borderColor: "border-indigo-200",
    icon: faTruck,
  },
  Almacenaje: {
    bgColor: "bg-orange-100",
    textColor: "text-orange-800",
    borderColor: "border-orange-200",
    icon: faWarehouse,
  },
  // Default styling for any status not explicitly defined
  default: {
    bgColor: "bg-gray-100",
    textColor: "text-gray-800",
    borderColor: "border-gray-200",
    icon: faCheckCircle,
  },
};

const StatusBadge = ({ status, showIcon = true, size = "md" }) => {
  // Get config for status or use default if not found
  const config = statusConfig[status] || statusConfig.default;

  // Size classes
  const sizeClasses = {
    sm: "px-2 py-0.5 text-xs",
    md: "px-2.5 py-1 text-sm",
    lg: "px-3 py-1.5 text-base",
  };

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium border ${config.bgColor} ${config.textColor} ${config.borderColor} ${sizeClasses[size]}`}
    >
      {showIcon && <FontAwesomeIcon icon={config.icon} className="mr-1" />}
      {status || "N/A"}
    </span>
  );
};

export default StatusBadge;
